import { useEffect, useMemo, useState } from 'react'

const DEFAULT_STATUSES = [
  'Thinking...',
  'Searching...',
  'Thinking...',
  'Typing...',
]

/** ~1.2s–2.2s between rotations (centered near 1.5s, slightly random). */
const MIN_DELAY_MS = 1200
const MAX_DELAY_MS = 2200

/**
 * Rotates typing status labels from conf.typingStatuses or defaults.
 * Uses chained timeouts so each interval length is random within [min, max].
 */
export function useTypingStatusRotation(conf) {
  const statuses = useMemo(() => {
    const configured = conf?.typingStatuses
    if (Array.isArray(configured) && configured.length > 0) {
      return configured
    }
    return DEFAULT_STATUSES
  }, [conf?.typingStatuses])

  const [statusIdx, setStatusIdx] = useState(0)

  useEffect(() => {
    setStatusIdx(0)
    if (statuses.length <= 1) return undefined

    let timeoutId
    const scheduleNext = () => {
      const delay =
        MIN_DELAY_MS + Math.random() * (MAX_DELAY_MS - MIN_DELAY_MS)
      timeoutId = setTimeout(() => {
        setStatusIdx((i) => (i + 1) % statuses.length)
        scheduleNext()
      }, delay)
    }
    scheduleNext()
    return () => clearTimeout(timeoutId)
  }, [statuses])

  const currentStatus = statuses[statusIdx] || 'Typing...'

  return { statuses, statusIdx, currentStatus }
}
